package com.sddamico.swigmore.ds.core

import androidx.compose.runtime.Composable
import com.sddamico.swigmore.ds.SwColor
import com.sddamico.swigmore.ds.css
import com.sddamico.swigmore.ds.typeBody
import com.sddamico.swigmore.ds.typeCaps
import com.sddamico.swigmore.ds.typeDisplay
import com.sddamico.swigmore.ds.typeMono
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

/** Gold uppercase kicker, e.g. "WEEK 8 POLL · RELEASED FRI, OCT 23 · 30 OF 30 BALLOTS". */
@Composable
fun Eyebrow(text: String, modifier: Modifier = Modifier, color: String = SwColor.gold, size: String = "11px") {
  Div(attrs = Modifier.typeCaps(size).css("color" to color).then(modifier).toAttrs()) { Text(text) }
}

/**
 * The page hero: eyebrow, big Graduate headline, optional lede. Matches the top of every screen.
 * [titleSize] defaults to the home-page clamp; inner screens use `clamp(30px,4.4vw,46px)`.
 */
@Composable
fun PageTitle(
  eyebrow: String,
  title: String,
  modifier: Modifier = Modifier,
  lede: String? = null,
  titleSize: String = "clamp(30px,4.4vw,46px)",
) {
  Div(attrs = modifier.toAttrs()) {
    Eyebrow(eyebrow)
    Div(attrs = Modifier.typeDisplay(titleSize).css("margin-top" to "10px", "text-wrap" to "balance").toAttrs()) {
      Text(title)
    }
    if (lede != null) {
      Div(
        attrs = Modifier.typeBody("15px", lineHeight = "1.5")
          .css("color" to SwColor.textSecondary, "margin-top" to "8px", "max-width" to "620px", "text-wrap" to "pretty")
          .toAttrs()
      ) { Text(lede) }
    }
  }
}

/** Section heading row: Graduate title left, mono caption right ("Top Eight" / "8–1 SCORING · MAX 240"). */
@Composable
fun SectionHeader(title: String, modifier: Modifier = Modifier, caption: String? = null) {
  Div(
    attrs = Modifier
      .css("display" to "flex", "justify-content" to "space-between", "align-items" to "baseline",
        "gap" to "12px", "flex-wrap" to "wrap", "margin-bottom" to "12px")
      .then(modifier)
      .toAttrs()
  ) {
    Span(attrs = Modifier.typeDisplay("22px", "normal").toAttrs()) { Text(title) }
    if (caption != null) {
      Span(attrs = Modifier.typeMono().css("color" to SwColor.textMuted, "text-transform" to "uppercase").toAttrs()) {
        Text(caption)
      }
    }
  }
}

/** Panel heading inside a Field card: gold caps label left, optional mono note right. */
@Composable
fun PanelLabel(label: String, modifier: Modifier = Modifier, note: String? = null) {
  Div(
    attrs = Modifier
      .css("display" to "flex", "justify-content" to "space-between", "align-items" to "baseline",
        "gap" to "10px", "margin-bottom" to "10px")
      .then(modifier)
      .toAttrs()
  ) {
    Span(attrs = Modifier.typeCaps("10px", ".18em").css("color" to SwColor.gold).toAttrs()) { Text(label) }
    if (note != null) {
      Span(attrs = Modifier.typeMono().css("color" to "rgba(239,229,201,.55)").toAttrs()) { Text(note) }
    }
  }
}
